import request from '../api/request'

export default {
  logged_in({ commit, state }) {
    state.working++
    return new Promise((resolve, reject) => {
      request
        .logged_in()
        .then(resp => {
          commit('updateLogin', resp.data['acl'])
          resolve(resp)
          state.working--
        })
        .catch(e => {
          reject(e)
          state.working--
        })
    })
  },
  async defines({ commit, state }) {
    state.working++
    return new Promise((resolve, reject) => {
      if (Object.keys(state.defines).length > 0) {
        resolve(state.defines)
        state.working--
        return
      }

      request.front
        .post('defines')
        .then(r => {
          commit('updateDefines', r.data)
          resolve(r.data)
          state.working--
        })
        .catch(e => {
          reject(e)
          state.working--
        })
    })
  }
}
